import { validatePhone } from "./tech.phone";
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
export function ajaxRequest(formRef, targetRef) {
    var form = $(formRef);
    var vanillaForm = document.querySelector(formRef);

    let validForm = form.valid();
    var extensionEnabled = vanillaForm.querySelector("#extensionInputValue") !== null ? vanillaForm.querySelector("#extensionInputValue").value : false;
    
    if (extensionEnabled) {
        var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));        
        var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
        var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);
        console.log(phoneNumber);
    
        if (validatePhone(phoneNumber, countrySelected) === false) {
            let errorSpan = vanillaForm.querySelector("#" +
                "welcome-phone-error-span");
            errorSpan.classList.remove('field-validation-valid');
            errorSpan.innerText = translations.tlfError;
            validForm = false;
        }
    }
  if (validForm) {
      var btn = form.find('button[data-loading-text]');
      if (btn.length > 0) {
          btn.html(btn.data('loading-text')).prop('disabled', true);
      }
      $.ajax({
          type: 'POST',
          url: form.attr('action'),
          data: form.serialize(),
          success: function(content) {
              let formId = formRef.replace("#", "");
              var vanForm = document.getElementById(formId);
              tech.core.setTrackingCookie(vanForm);
              $(targetRef).html(content);
          },
          complete: function() {
              if (btn.length > 0) {
                  btn.html(btn.data('text')).prop('disabled', false);
              }
          },
          error: function() {
              form.find('.general-validation-error').text(form.data("error-msg"));
          }
      });
  }
}